import {faTriangleExclamation} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex, Typography} from 'antd';
import {ReactElement, useMemo, useState} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {gray7} from '../../../../../../../../css/var-export.scss';
import {Locale} from '../../../../../../../../provider/locale/locale';
import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';
import {isAutoAbuseCreate} from '../../../../../../../../service/reviews/reviews-abuse-log-helper';
import {LogActionsEnum} from '../../../../../review-logs/review-log-type';

type PropsType = {
    action: string;
    formattedDate: string | null;
    formattedTime: string | null;
    oldValue: string | null;
    userName: string;
    value: string;
};

export function AbuseLog(props: PropsType): ReactElement {
    const {formattedDate, formattedTime, action, userName, value, oldValue} = props;

    const [expanded, setExpanded] = useState(false);

    const isAutoComplaint = action === LogActionsEnum.Created && isAutoAbuseCreate(oldValue);

    const headingLocaleString = useMemo((): LangKeyType => {
        if (isAutoComplaint) {
            return 'REVIEWS__REVIEW_ABUSE_AUTO_SENT';
        }

        if (action === LogActionsEnum.Created) {
            return 'REVIEWS__REVIEW_ABUSE_CREATED_BY';
        }

        if (action === LogActionsEnum.Deleted) {
            return 'REVIEWS__REVIEW_ABUSE_DELETED_BY';
        }

        return 'REVIEWS__REVIEW_ABUSE_UPDATED_BY';
    }, [action, isAutoComplaint]);

    const showComplaintText = Boolean(value) && action !== LogActionsEnum.Deleted;

    return (
        <div>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Flex gap={4} vertical>
                <Flex align="center" gap={8}>
                    <FontAwesomeIcon color={gray7} fontSize={16} icon={faTriangleExclamation} />
                    {isAutoComplaint ? (
                        <Text lighter stringKey={headingLocaleString} />
                    ) : (
                        <Text
                            lighter
                            stringKey={headingLocaleString}
                            valueMap={{user: <Text bolder>{userName}</Text>}}
                        />
                    )}
                </Flex>
                {showComplaintText && (
                    <Typography.Paragraph
                        ellipsis={{
                            rows: 1,
                            expandable: 'collapsible',
                            expanded,
                            onExpand: (_data, info) => setExpanded(info.expanded),
                            symbol: (
                                <Locale
                                    stringKey={
                                        expanded
                                            ? 'REVIEWS__REVIEW_ABUSE__HIDE_TEXT'
                                            : 'REVIEWS__REVIEW_ABUSE__SHOW_TEXT'
                                    }
                                />
                            ),
                        }}
                        type="secondary"
                    >
                        {value}
                    </Typography.Paragraph>
                )}
            </Flex>
        </div>
    );
}
